import React, { useState, useEffect } from "react";
import "./style.css";
import Moment from "react-moment";
import cogoToast from "@successtar/cogo-toast";

function MasterControlAuto({ auto, agentID }) {
  const [formData, setFormData] = useState({
    commissions: "",
    split: ""
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
    setTimeout(() => {
      calculateCommissions(agentID);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const calculateCommissions = (agentId) => {
    let commissions = 0;
    let split = 0;

    if (agentId === auto.mainAgent) {
      commissions = auto.premium * (auto.mainAgentSplit / 100) * 0.055;
      split = auto.mainAgentSplit;
    } else if (agentId === auto.refAgentOne) {
      commissions = auto.premium * (auto.refAgentOneSplit / 100) * 0.055;
      split = auto.refAgentOneSplit;
    } else if (agentId === auto.refAgentTwo) {
      commissions = auto.premium * (auto.refAgentTwoSplit / 100) * 0.055;
      split = auto.refAgentTwoSplit;
    } else if (agentId === auto.refAgentThree) {
      commissions = auto.premium * (auto.refAgentThreeSplit / 100) * 0.055;
      split = auto.refAgentThreeSplit;
    } else if (agentId === auto.refAgentFour) {
      commissions = auto.premium * (auto.refAgentFour / 100) * 0.055;
      split = auto.refAgentFourSplit;
    }

    setTimeout(() => {
      setFormData({
        commissions: commissions,
        split: split
      });
    }, 500);
  };

  const viewPolicy = (event) => {
    event.preventDefault();
    console.log("Getting Policy information");
    cogoToast.warn("Website Feature coming soon!");
  };

  const { split, commissions } = formData;

  return (
    <tr key={auto._id} style={{ backgroundColor: "white" }}>
      <td>Auto</td>
      <td>
        <strong>{auto.clientFirstName + " " + auto.clientLastName}</strong>
      </td>
      <td>{auto.policyActive ? "Active" : "Inactive"}</td>
      <td>${auto.premium}</td>
      <td>
        {split ? <>{parseInt(split).toFixed(0)}%</> : <img alt="loading" src="/loading.gif" />}
      </td>
      <td>
        {commissions ? (
          <>${parseInt(commissions).toFixed(3)}</>
        ) : (
          <img alt="loading" src="/loading.gif" />
        )}
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {auto.effectiveDate}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {auto.updatedAt}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
          {auto.created_at}
        </Moment>
      </td>
      <td>
        <button
          className="btn btn-small btn-black"
          style={{ width: "100%" }}
          onClick={(e) => viewPolicy(e)}
        >
          View
        </button>
      </td>
    </tr>
  );
}

export default MasterControlAuto;
